<template>
  <div
    class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden"
  >
    <div class="p-4">
      <div
        class="flex"
        :class="{ 'items-start': message.text, 'items-center': !message.text }"
      >
        <div class="flex-shrink-0">
          <!-- Heroicon name: outline/check-circle -->
          <div
            v-if="message.type == 'success'"
            class="h-7 w-7 text-green-400 rounded-full border-2 border-green-400 rounded-full flex items-center justify-center text-sm"
            style="line-height: inherit;"
          >
            <i class="far fa-check fa-fw" style="line-height: inherit;"></i>
          </div>

          <div
            v-if="message.type == 'info'"
            class="h-7 w-7 text-blue-400 rounded-full border-2 border-blue-400 rounded-full flex items-center justify-center text-sm"
            style="line-height: inherit;"
          >
            <i class="fas fa-info fa-fw" style="line-height: inherit;"></i>
          </div>

          <div
            v-if="message.type == 'warning'"
            class="h-7 w-7 text-yellow-400 rounded-full border-2 border-yellow-400 rounded-full flex items-center justify-center text-sm"
            style="line-height: inherit;"
          >
            <i
              class="fas fa-exclamation fa-fw"
              style="line-height: inherit;"
            ></i>
          </div>

          <div
            v-if="message.type == 'error'"
            class="h-7 w-7 text-red-400 rounded-full border-2 border-red-400 rounded-full flex items-center justify-center text-sm"
            style="line-height: inherit;"
          >
            <i class="far fa-times fa-fw" style="line-height: inherit;"></i>
          </div>
        </div>
        <div
          class="ml-3 w-0 flex-1"
          :class="{
            'pt-0.5': message.text
          }"
        >
          <p class="text-sm font-medium text-gray-900">
            {{ message.title }}
          </p>
          <p class="mt-1 text-sm text-gray-500" v-if="message.text">
            {{ message.text }}
          </p>
        </div>
        <div class="ml-4 flex-shrink-0 flex">
          <button
            class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            v-on:click="closeToast(message.id)"
          >
            <span class="sr-only">Close</span>
            <!-- Heroicon name: solid/x -->
            <svg
              class="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "ToastCard",
  props: ["message"],
  methods: {
    ...mapActions(["removeToastMessage"]),
    closeToast(toastId) {
      this.removeToastMessage(toastId);
    }
  }
};
</script>
